import { render, staticRenderFns } from "./searchIndex.vue?vue&type=template&id=dde8456a&"
import script from "./searchIndex.vue?vue&type=script&lang=js&"
export * from "./searchIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports